// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberRange_root__u3uVU","separator":"NumberRange_separator__3DRt3"};